module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"post":"Post","error_occurred":"An error has occurred.","place_holder":"Please input the text within 140 characters.","add_comment":"The comment was added.","post_tag_errMsg":"Could not post the tag. <br>Your network condition may be bad. <br>Please check your network condition and try again."}}')
  delete Component.options._Ctor
}
